import { cn } from "@/lib/utils"

interface AdminPageProps {
  children: React.ReactNode
  maxWidth?: "default" | "narrow" | "wide"
}

export function AdminPage({ children, maxWidth = "default" }: AdminPageProps) {
  return (
    <div
      className={cn(
        "p-6 lg:p-8",
        maxWidth === "narrow" && "max-w-4xl",
        maxWidth === "wide" && "max-w-6xl",
      )}
    >
      {children}
    </div>
  )
}
